import { useSelector } from 'react-redux';
import { getEndpointRetries } from '../../store/http-responses/selectors';
import { getGTKMDataKeys, getGTKMDataKeysWithoutDomain, getSU0004ReviewRequiredDataKeys } from '../../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { useIsDataPointValid } from '../../hooks/useIsStepDataValid';
import { getGTKMEndpointKey } from './getGTKMEndpointKey';
export const useIsFilteredGTKMDataValid = getDataKeys => {
  const endpointKey = useSelector(getGTKMEndpointKey);
  const gtkmRetries = useSelector(state => getEndpointRetries(state, endpointKey));
  const dataKeysSelector = getDataKeys !== null && getDataKeys !== void 0 ? getDataKeys : getGTKMDataKeys;
  let gtkmDataKeys = useSelector(dataKeysSelector);
  if (gtkmRetries === 1) {
    gtkmDataKeys = gtkmDataKeys.filter(key => key !== Data.CompanyDomain);
  }
  const isGTKMDataValid = useIsDataPointValid(gtkmDataKeys);
  return isGTKMDataValid;
};
export const useIsGTKMDataValidWithoutDomain = () => useIsFilteredGTKMDataValid(getGTKMDataKeysWithoutDomain);
export const useIsSU0004ReviewDataValid = () => useIsFilteredGTKMDataValid(getSU0004ReviewRequiredDataKeys);